module.exports = __webpack_public_path__ + "r-v3/img/sticker_19.6d8abdba.svg";